var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.4 23.4",
    style: {
      enableBackground: "new 0 0 23.4 23.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D61983;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,15.2c0.4-0.7,1.1-1.1,1.9-1.1c0.9,0,1.3-0.4,1.3-1.3c0-0.9,0.4-1.5,1.1-1.9c0.7-0.4,0.9-1,0.5-1.8 c-0.4-0.7-0.4-1.5,0-2.2c0.4-0.7,0.3-1.3-0.5-1.8c-0.7-0.4-1.1-1.1-1.1-1.9c0-0.9-0.4-1.3-1.3-1.3c-0.9,0-1.5-0.4-1.9-1.1 c-0.4-0.7-1-0.9-1.8-0.5c-0.7,0.4-1.5,0.4-2.2,0C9.8-0.2,9.2,0,8.8,0.7C8.4,1.4,7.7,1.8,6.9,1.8C6,1.8,5.6,2.3,5.6,3.1 c0,0.9-0.4,1.5-1.1,1.9C3.7,5.5,3.6,6.1,4,6.8c0.4,0.7,0.4,1.5,0,2.2c-0.4,0.7-0.3,1.3,0.5,1.8c0.7,0.4,1.1,1.1,1.1,1.9 c0,0.9,0.4,1.3,1.3,1.3c0.9,0,1.5,0.4,1.9,1.1c0.4,0.7,1,0.9,1.8,0.5c0.7-0.4,1.5-0.4,2.2,0C13.6,16.1,14.1,15.9,14.6,15.2z  M11.7,12.6C9.1,12.6,7,10.5,7,7.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C16.4,10.5,14.3,12.6,11.7,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,14.7c-0.9,0-1-0.4-1-0.4l-3.5,6.9l2.8-0.3l1.6,2.3c0,0,3.2-6.8,3.2-6.7C8.2,16.5,8.9,14.8,6.8,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,14.6c-2.6,0.3-2,0.9-2.6,1.4c-0.7,0.7-1.5,0.6-1.5,0.6l4,6.8l1-2.5l2.8,0.4L17.6,14.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.7,6.9 11.7,4.9 10.7,6.9 8.5,7.2 10.1,8.8 9.7,11 11.7,9.9 13.7,11 13.3,8.8 14.9,7.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.aa4fe8a1759c8e1c4c7be74e3853a499.svg";
export { ForwardRef as ReactComponent };